import { Entity } from "src/app/core/utils/entity";

export abstract class DeleteClaimEntity extends Entity {
    constructor(
        public id: string
    ) {
        super();
    }
}